import React from "react";
import { JERSEY_STYLES, fmt } from "@/api";

export function JerseyBadge({ jersey, size = "md" }) {
  const s = JERSEY_STYLES[jersey] || JERSEY_STYLES.black;
  const dims = size === "lg" ? "w-14 h-14 text-lg" : size === "sm" ? "w-8 h-8 text-[10px]" : "w-11 h-11 text-xs";
  return (
    <div
      data-testid={`jersey-${jersey}`}
      className={`${dims} shrink-0 flex items-center justify-center font-black uppercase`}
      style={{ background: s.bg, color: s.fg, border: `4px solid ${s.border === s.bg ? "#0A0A0A" : s.border}` }}
      title={s.label}
    >
      {s.label[0]}
    </div>
  );
}

export function ScorePill({ w }) {
  const excellent = w.avg >= 8;
  return (
    <span
      className={`inline-flex items-center justify-center px-2 py-1 font-score text-2xl leading-none border-2 ${
        w.counting ? "border-black" : "border-gray-300 text-gray-400"
      } ${excellent && w.counting ? "excellent-glow" : ""}`}
      style={{ background: w.counting ? "#F3F4F6" : "transparent" }}
    >
      {fmt(w.avg)}
    </span>
  );
}

export function BigTimer({ timer, large = false }) {
  const [remaining, setRemaining] = React.useState(timer?.remaining_sec ?? 0);
  const endRef = React.useRef(null);

  React.useEffect(() => {
    if (timer?.running) {
      endRef.current = Date.now() + timer.remaining_sec * 1000;
    } else {
      endRef.current = null;
      setRemaining(timer?.remaining_sec ?? 0);
    }
  }, [timer?.running, timer?.remaining_sec]);

  React.useEffect(() => {
    const id = setInterval(() => {
      if (endRef.current) {
        setRemaining(Math.max(0, Math.round((endRef.current - Date.now()) / 1000)));
      }
    }, 250);
    return () => clearInterval(id);
  }, []);

  if (!timer || (!timer.duration_sec && !timer.running)) {
    return (
      <div data-testid="timer-idle" className={`brutal-2 px-4 py-2 text-center bg-gray-100 ${large ? "" : ""}`}>
        <span className="font-display text-xs tracking-[0.2em] uppercase text-gray-500">Timer not started</span>
      </div>
    );
  }

  const over = remaining <= 0;
  const warning = !over && remaining <= 120;
  const m = Math.floor(remaining / 60);
  const s = remaining % 60;
  const cls = over ? "heat-over-flash" : warning ? "timer-warning" : "bg-black text-white";
  const sizeCls = large ? "text-8xl sm:text-9xl" : "text-6xl sm:text-7xl";

  return (
    <div data-testid="heat-timer" className={`w-full text-center ${cls} border-4 border-black px-4 py-2`}>
      {over ? (
        <div className="font-display uppercase font-black text-lg sm:text-2xl py-3 tracking-tight" data-testid="heat-over-msg">
          Heat Over — Riders Out · Scores Finalizing
        </div>
      ) : (
        <div className={`font-score ${sizeCls} leading-none`}>
          {m}:{String(s).padStart(2, "0")}
        </div>
      )}
    </div>
  );
}
